<template>
    <ProfessionsView />
  </template>
  
  <script>
  import ProfessionsView from '@/components/common/profession/ProfessionView.vue'
  
  export default {
    name: 'ViewProfession',
    components: { ProfessionsView }
  }
  </script>
  
  <style scoped>
  
  </style>
  